// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UHgkN","icon":"styles_icon__1D8Qt"};